import { render } from "./SectionCollection.vue?vue&type=template&id=88ff8cb2"
import script from "./SectionCollection.vue?vue&type=script&lang=js"
export * from "./SectionCollection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__